
import { getTableColumnNames } from "@/utils/reminder-layouts/reminder-layout";
import Vue from "vue";
export default Vue.extend({
	props: {
		lang: String
	},
	computed: {
		cols(): string[] {
			return getTableColumnNames().map(t => t.getTranslation(this.lang));
		}
	}
});
